class ProductOptionsModal extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("#product-options-form");
    this.atcButton = this.querySelector(".add-to-cart");
    this.totalAwardsSelector = this.querySelector("#award-count");
    this.totalAwards = 1;

    this.totalAwardsSelector.addEventListener("change", (e) =>
      this.handleAwardsChange(e)
    );
    this.form.addEventListener("submit", (e) => this.addToCart(e));
  }

  connectedCallback() {
    this.renderAwardFields(this.totalAwards);

    const input = document.querySelector('product-form input[name="id"]');

    const config = {
      attributes: true,
      childList: false,
      subtree: false,
      characterData: true,
    };

    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" ||
          mutation.type === "characterData"
        ) {
          this.form.querySelector('input[name="id"]').value = input.value;
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(input, config);
  }

  handleAwardsChange(e) {
    this.totalAwards = e.target.value;
    this.renderAwardFields(this.totalAwards);
  }

  renderAwardFields(quantity) {
    const container = this.querySelector("#awards-container");
    const template = this.querySelector("#award-template");

    container.innerHTML = "";

    for (let i = 1; i <= quantity; i++) {
      const awardElement = template.content.cloneNode(true);
      awardElement.querySelector(".award-number").textContent = i;

      const awardNameInput = awardElement.querySelector(".award-name");
      const recipientNameInput = awardElement.querySelector(".recipient-name");

      awardNameInput.name = `properties[Award ${i} Name]`;
      recipientNameInput.name = `properties[Award ${i} Recipient]`;

      container.appendChild(awardElement);
    }
  }

  addToCart(e) {
    e.preventDefault();
    this.atcButton.classList.add("is-loading");

    const formData = new FormData(this.form);
    const quantity = parseInt(this.totalAwardsSelector.value);

    const newFormData = new FormData();
    const feeKey = Date.now();

    // Setup fee
    newFormData.append("items[0][id]", "41350297485375");
    newFormData.append("items[0][quantity]", 1);
    newFormData.append("items[0][properties][__key]", feeKey);

    // Capture checkbox value for cart note and item property
    const emailLaterCheckbox = this.form.querySelector("#email-later");
    const emailLaterNote = emailLaterCheckbox.checked
      ? "Customer will email details later"
      : "";

    for (let i = 1; i <= quantity; i++) {
      newFormData.append(`items[${i}][id]`, formData.get("id"));
      newFormData.append(`items[${i}][quantity]`, 1);
      newFormData.append(
        `items[${i}][properties][Organization]`,
        formData.get("properties[Organization]")
      );
      newFormData.append(
        `items[${i}][properties][Organization Logo]`,
        formData.get("properties[Organization Logo]")
      );
      newFormData.append(
        `items[${i}][properties][Year]`,
        formData.get("properties[Year]")
      );
      newFormData.append(
        `items[${i}][properties][Award Name]`,
        formData.get(`properties[Award ${i} Name]`)
      );
      newFormData.append(
        `items[${i}][properties][Award Recipient]`,
        formData.get(`properties[Award ${i} Recipient]`)
      );
      newFormData.append(`items[${i}][properties][__fee_key]`, feeKey);

      // Add emailLaterNote as an item property
      if (emailLaterNote) {
        newFormData.append(`items[${i}][properties][Details]`, emailLaterNote);
      }
    }

    // Add Cart Note (if checkbox is checked)
    if (emailLaterNote) {
      newFormData.append("note", emailLaterNote);
    }

    fetch("/cart/add.js", {
      method: "POST",
      body: newFormData,
    })
      .then((response) => response.json())
      .then(() => {
        document.dispatchEvent(
          new CustomEvent("theme:cart:init", { bubbles: true })
        );
        this.style.display = "none";
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:cart:reload", { bubbles: true })
          );
          document.querySelector('[data-drawer-toggle="drawer-cart"]').click();
          this.atcButton.classList.remove("is-loading");
        }, 500);
      })
      .catch((error) => console.error(error));
  }
}

customElements.define("product-options-modal", ProductOptionsModal);
